export const popularAirports = {
    en: [
        {
            priority: 1,
            nearby: false,
            text: 'Cairo',
            score: 362,
            payload: {
                airportId: 'CAI',
                airportCode: 'CAI',
                weight: 4,
                cityId: '50156',
                provinceId: '43497',
                cityName: 'Cairo',
                airportName: 'Cairo International Airport',
                countryName: 'Egypt',
                countryCode: 'EG',
                countryMisspell: '',
                cityMisspell: 'caero cairow cairu kairo',
                score: 362.50705
            }
        },
        {
            priority: 1,
            nearby: false,
            text: 'Jeddah',
            score: 399,
            payload: {
                airportId: 'JED',
                airportCode: 'JED',
                weight: 4,
                cityId: '50419',
                provinceId: '22051',
                cityName: 'Jeddah',
                airportName: 'Jeddah King Abdul Aziz International Airport',
                countryName: 'Saudi Arabia',
                countryCode: 'SA',
                countryMisspell: '',
                cityMisspell: 'giddah giddah giddah jedah jedah jedah jiddah jiddah jiddah',
                score: 399.90353
            }
        },
        {
            priority: 1,
            nearby: false,
            text: 'Riyadh',
            score: 260,
            payload: {
                airportId: 'RUH',
                airportCode: 'RUH',
                weight: 8,
                cityId: '50754',
                provinceId: '45178',
                cityName: 'Riyadh',
                airportName: 'King Khalid International Airport',
                countryName: 'Saudi Arabia',
                countryCode: 'SA',
                countryMisspell: '',
                cityMisspell: 'reiadh riadh riyad ryadh',
                score: 260.17447
            }
        },
        {
            priority: 1,
            nearby: false,
            text: 'Madinah',
            score: 255,
            payload: {
                airportId: 'MED',
                airportCode: 'MED',
                weight: 4,
                cityId: '50541',
                provinceId: '45177',
                cityName: 'Madinah',
                airportName: 'Prince Mohammad Bin Abdulaziz International Airport',
                countryName: 'Saudi Arabia',
                countryCode: 'SA',
                countryMisspell: '',
                cityMisspell: '',
                score: 255.22108
            }
        },
        {
            priority: 1,
            nearby: false,
            text: 'Abha',
            score: 255,
            payload: {
                airportId: 'AHB',
                airportCode: 'AHB',
                weight: 4,
                cityId: '51173',
                provinceId: '45184',
                cityName: 'Abha',
                airportName: 'Abha Regional Airport',
                countryName: 'Saudi Arabia',
                countryCode: 'SA',
                countryMisspell: '',
                cityMisspell: '',
                score: 255.29361
            }
        },
        {
            priority: 1,
            nearby: false,
            text: 'Dammam',
            score: 226,
            payload: {
                airportId: 'DMM',
                airportCode: 'DMM',
                weight: 4,
                cityId: '50232',
                provinceId: '45183',
                cityName: 'Dammam',
                airportName: 'King Fahd International Airport',
                countryName: 'Saudi Arabia',
                countryCode: 'SA',
                countryMisspell: '',
                cityMisspell: 'AL-DAMMAM damam damamm dmam dmmam مطار الملك',
                score: 226.22174
            }
        },
        {
            priority: 1,
            nearby: false,
            text: 'Aswan',
            score: 414,
            payload: {
                airportId: 'ASW',
                airportCode: 'ASW',
                weight: 4,
                cityId: '50054',
                provinceId: '43489',
                cityName: 'Aswan',
                airportName: 'Aswan International Airport',
                countryName: 'Egypt',
                countryCode: 'EG',
                countryMisspell: '',
                cityMisspell: 'asoan asoan asouan asouan asowan asowan asuan asuan',
                score: 414.74573
            }
        }
    ],
    ar: [
        {
            priority: 1,
            nearby: false,
            text: 'القاهرة',
            score: 314,
            payload: {
                airportId: 'CAI',
                airportCode: 'CAI',
                weight: 4,
                cityId: '50156',
                provinceId: '43497',
                cityName: 'القاهرة',
                airportName: 'القاهرة الدولي',
                countryName: 'مصر',
                countryCode: 'EG',
                countryMisspell: '',
                cityMisspell: 'القاهره مصر القاهرة مطار الق',
                score: 314.30823
            }
        },
        {
            priority: 1,
            nearby: false,
            text: 'جدة',
            score: 319,
            payload: {
                airportId: 'JED',
                airportCode: 'JED',
                weight: 4,
                cityId: '50419',
                provinceId: '22051',
                cityName: 'جدة',
                airportName: 'الملك عبد العزيز',
                countryName: 'المملكة العربية السعودية',
                countryCode: 'SA',
                countryMisspell: 'المملكة العربية السعودية',
                cityMisspell: 'جده جدا جدى جدة مطار جد جاده جادة جأده جأدة جإده جإدة',
                score: 319.05475
            }
        },
        {
            priority: 1,
            nearby: false,
            text: 'الرياض',
            score: 316,
            payload: {
                airportId: 'RUH',
                airportCode: 'RUH',
                weight: 8,
                cityId: '50754',
                provinceId: '45178',
                cityName: 'الرياض',
                airportName: 'الرياض',
                countryName: 'المملكة العربية السعودية',
                countryCode: 'SA',
                countryMisspell: 'المملكة العربية السعودية',
                cityMisspell: 'الرياط الريات ألرياض إلرياض ألرياط إلرياط ألريات رياض رياط ريات',
                score: 316.16135
            }
        },
        {
            priority: 1,
            nearby: false,
            text: 'المدينة المنورة',
            score: 545,
            payload: {
                airportId: 'MED',
                airportCode: 'MED',
                weight: 4,
                cityId: '50541',
                provinceId: '45177',
                cityName: 'المدينة المنورة',
                airportName: 'الأمير محمد بن عبدالعزيز',
                countryName: 'المملكة العربية السعودية',
                countryCode: 'SA',
                countryMisspell: 'المملكة العربية السعودية',
                cityMisspell:
                    'المدينه ال المدينه المنوره المدينه المنور المدينه المن المدينه ا المدينه المنو المدينه الم المدينه المدينة المنورة المادينه المنوره المادينة المنورة',
                score: 545.7851
            }
        },
        {
            priority: 1,
            nearby: false,
            text: 'أبها',
            score: 363,
            payload: {
                airportId: 'AHB',
                airportCode: 'AHB',
                weight: 4,
                cityId: '51173',
                provinceId: '45184',
                cityName: 'أبها',
                airportName: 'مطار أبها',
                countryName: 'المملكة العربية السعودية',
                countryCode: 'SA',
                countryMisspell: 'المملكة العربية السعودية',
                cityMisspell: 'ابها ابه',
                score: 363.8051
            }
        },
        {
            priority: 1,
            nearby: false,
            text: 'الدمام',
            score: 84,
            payload: {
                airportId: 'DMM',
                airportCode: 'DMM',
                weight: 4,
                cityId: '50232',
                provinceId: '45183',
                cityName: 'الدمام',
                airportName: 'الملك فهد الدولي',
                countryName: 'المملكة العربية السعودية',
                countryCode: 'SA',
                countryMisspell: 'المملكة العربية السعودية',
                cityMisspell: 'الدمأم الدمإم ألدمأم إالدمإم دمام دمأم دمإم',
                score: 84.11074
            }
        },
        {
            priority: 1,
            nearby: false,
            text: 'أسوان',
            score: 396,
            payload: {
                airportId: 'ASW',
                airportCode: 'ASW',
                weight: 4,
                cityId: '50054',
                provinceId: '43489',
                cityName: 'أسوان',
                airportName: 'اسوان',
                countryName: 'مصر',
                countryCode: 'EG',
                countryMisspell: '',
                cityMisspell: 'أصوان اسوان إسوان أسوأن إسوأن اسوأن أسوإن إسوإن اسوإن',
                score: 396.96295
            }
        }
    ]
}
